import { z } from "zod";
import { NPC_ARCHETYPES } from "@frontier/content/npcs";

export const contractNpcArchetypeSchema = z.enum(NPC_ARCHETYPES);
